import { WizardButton } from '@iheartjane/menu';
import { Flex } from '@iheartjane/reefer';
import { useLoaderData } from 'react-router';

import { BloomWizardModal } from '@jane/bloom/components/bloomWizardModal';
import { useShowInlineWizardCta } from '@jane/bloom/hooks/useShowInlineWizardCta';
import type { RecommendedSortResults } from '@jane/bloom/loaders/products/recommendedSortResults.server';
import { WIZARD_SOURCE } from '@jane/bloom/services/tracking/Events';

import { SearchDropdown } from './searchDropdown';
import { SearchFieldButton } from './searchFieldButton';

import styles from './searchContentHeader.module.css';

/**
 * The `content_header` search placement: a full-width search bar rendered below
 * the header and above the carousel, with the AI Budtender button inside it.
 *
 * Desktop shows an inline suggestions dropdown directly beneath the field.
 * Mobile has no inline dropdown — focusing the field opens the shared
 * `SearchFullscreen` overlay (mounted by the header) via the global search
 * state, matching mobile search behavior elsewhere in Bloom.
 */
export const SearchContentHeader = () => {
  const { brandSpecials, enabledSpecialsForRow } =
    useLoaderData<RecommendedSortResults>();
  const showWizardCta = useShowInlineWizardCta();

  return (
    <Flex
      className={styles['searchContentHeader']}
      alignItems="center"
      justifyItems="center"
      flexDirection="row"
      minWidth={0}
      maxWidth="100%"
      background="grays-white"
      border="grays-light"
      borderRadius="xl"
      pr={8}
    >
      <div>
        {/* make the dropdown the full width of the search bar(search field width + button/padding width) */}
        <SearchDropdown dropdownWidth="calc(100% + 177px)" />
        <SearchFieldButton />
      </div>
      {showWizardCta && (
        <BloomWizardModal
          brandSpecials={brandSpecials}
          specials={enabledSpecialsForRow}
        >
          {({ openModal }) => (
            <WizardButton
              className={styles['wizardButton']}
              label={
                <>
                  Help me
                  <span className={styles['wizardButtonLabel']}> choose</span>
                </>
              }
              onClickStart={() => openModal(WIZARD_SOURCE.BUTTON)}
            />
          )}
        </BloomWizardModal>
      )}
    </Flex>
  );
};
